export type WS_CHAT_TYPE = 'CHATv1'
export type WS_DATA_TYPE_CMD = 'CMD'
export type WS_CMD_RESPONSE = 'CMD_R'
export type WS_CMDs =
  | 'get.chats/active+unseen'
  | 'get.chats/history'
  | 'delete.chat'

export const WS_DATA_VALUE_CMD: WS_DATA_TYPE_CMD = 'CMD'
export const WS_CHAT_TYPE_VALUE: WS_CHAT_TYPE = 'CHATv1'
export const WS_CHAT_VALUE_CMD_R: WS_CMD_RESPONSE = 'CMD_R'

export interface WSConfig {
  host: string
  ssl: boolean
  initPath: string
  connectPath: string
  connectAdminPath?: string
}

export interface WSEvent<D, M> {
  type: WS_CHAT_TYPE | string
  data?: D
  metadata?: M
}

export type WSSubscription<D, M> = (e: WSEvent<D, M>) => void

interface DirectChatMessageData {
  text: string
}

interface DirectChatMessageMeta {
  recipient?: {
    id: string
    name?: string
  }
  sender?: {
    id: string
    name?: string
  }
}

export class DirectChatMessage
  implements WSEvent<DirectChatMessageData, DirectChatMessageMeta>
{
  type = 'DIRECT_CHAT_MESSAGE'
  data: {text: string}
  metadata: {
    recipient?: {
      id: string
      name?: string
    }
    sender?: {
      id: string
      name?: string
    }
  }

  constructor(recipientId: string, message: string) {
    this.data = {text: message}
    this.metadata = {recipient: {id: recipientId}}
  }
}
